import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function appBar(theme: Theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease',
        },
      },
    },
  };
}
